import PropTypes from "prop-types";
import { doPostFetch } from "@Src/api/apiFetchHelper";

export const translateText = async (text, callback, target) => {
  const result = await doPostFetch("/api/translate", { text: text, target: target });
  callback(result);
};
translateText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  callback: PropTypes.func,
  target: PropTypes.string,
};
